module.exports = __webpack_public_path__ + "media/3ab199c0d8b44314b7d8760ef28d028e.641bb5fd.mp4";